const uniqueId = (prefix) => `${prefix ? prefix + '-' : ''}${Date.now()}-${Math.random() * 1000}`;

export { uniqueId };
